// extracted by mini-css-extract-plugin
export default {"container":"InfoBox__container-MTlRU","error":"InfoBox__error-ysrHN","info":"InfoBox__info-_vbEu","success":"InfoBox__success-mNCjP"};